export default class SportNotSupportedError extends Error {
    constructor() {
        super("Sport not supported");
    }
}
